module.exports = __webpack_public_path__ + "img/order_complete_wishope.f1a8f2e2.png";